module.exports = {
  INTERVAL: 'interval',
  ON_DEMAND: 'on-demand',
};
